module.exports = __webpack_public_path__ + "static/media/MICHELL T8 TONEARM.f355f093.png";